import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* 모든 요소에 공통 폰트 적용 */
  * {
    font-family: 'Pretendard';
  }
`;

export default GlobalStyle;